import { useCallback } from 'react';
import { useSubscriptionsApi } from '@/context';
import { useProfileResource } from '@/users/components/auth/profileRequests';
export function useBillingDemo(teamSlug: string) {
  const api = useSubscriptionsApi();
  const load = useCallback(() => api.subscriptionDemoRetrieve({ teamSlug }), [api, teamSlug]);
  return useProfileResource(load, 'Could not load subscription access. Please retry.');
}
